import React from 'react';
import { useSearchParams } from 'react-router-dom';

import EmptyView from '../../../design-system/EmptyView/EmptyView';
import { LoopRightFillIcon } from '../../../design-system/Icons';

const CyclesEmptyView = () => {
    const [searchParams] = useSearchParams();
    const isSearchQuery = !!searchParams.get('search');

    if (isSearchQuery) {
        return (
            <p className="font-body text-body-bold-s text-neutral-300 px-1 max-w-[600px]">
                No CRAFT Cycles found. Please adjust your search and try again!
            </p>
        );
    }

    return (
        <EmptyView
            icon={LoopRightFillIcon}
            mainText="You don't have any CRAFT Cycles yet."
            mainTextAdditionalStyles="max-w-[450px]"
            withButton={false}
        />
    );
};
export default CyclesEmptyView;
